import { Spinner } from "@mixitone/components";
import { ApplicationView } from "@mixitone/mvc";
import clsx from "clsx";
import Sync from "components/Pages/Sync/Sync";
import SessionController from "controllers/SessionController";
import TauriController from "controllers/TauriController";
import tauri from "lib/tauri";
import { Outlet } from "react-router-dom";

const Tauri: React.FC = () => {
  const sessionController = SessionController.use();
  const { loginState } = sessionController.state;

  if (tauri.enabled && loginState === "unknown") {
    return <Sync />;
  }

  if (loginState === "unknown") {
    return (
      <div className={clsx("h-screen bg-brand-600")}>
        <div
          className={clsx(
            "flex h-full w-full items-center justify-center bg-slate-800 bg-gradient-to-r from-slate-700 to-slate-800 sm:flex-col sm:bg-gradient-to-b",
          )}
        >
          <Spinner size={128} className="fill-brand-600" />
        </div>
      </div>
    );
  }

  return <Outlet />;
};

export default TauriController.scope(ApplicationView(Tauri));
